<header class="page-head" data-testid="broadcasts-filter-section" *ngIf="administrator">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-search"></i></span>
    <div>
      <h1 class="page-head__title">Analisar SMS Massivo</h1>
      <p class="page-head__subtitle">
        Busca em todos os envios em massa de todos os clientes: por nome, provedor, texto da
        mensagem e período.
      </p>
    </div>
  </div>
</header>

<form *ngIf="administrator" (submit)="onFilter()">
  <div class="filter-bar">
    <div class="search-wrap grow">
      <i class="fa fa-search"></i>
      <input
        type="text"
        name="name"
        [(ngModel)]="name"
        class="form-control"
        placeholder="Nome do envio massivo"
        data-testid="input-name"
      />
      <button type="submit" class="search-go" data-testid="btn-search" aria-label="Pesquisar">
        <i class="fa fa-search"></i>
      </button>
    </div>

    <div class="m8v-period" title="Período (data inicial e final)">
      <i class="fa fa-calendar-o ic"></i>
      <input type="date" [(ngModel)]="startedMonth" name="startedMonth" data-testid="input-started-month" />
      <span class="sep">até</span>
      <input type="date" [(ngModel)]="endedMonth" name="endedMonth" data-testid="input-ended-month" />
      <small class="err" *ngIf="startedMonth && endedMonth && startedMonth > endedMonth" data-testid="invalid-period">
        Período inválido.
      </small>
    </div>
  </div>

  <div class="filter-bar filter-bar--selects">
    <div class="field">
      <label>Provedores</label>
      <app-search-select
        [options]="providerOptions"
        [ngModel]="providerAccountId"
        [ngModelOptions]="{standalone: true}"
        (selectionChange)="onProviderChange($event)"
        placeholder="Todos os provedores"
        searchPlaceholder="Pesquisar provedor…"
        emptyText="Nenhum provedor encontrado"
        noun="provedores"
        testId="broadcasts-filter-provider"
      ></app-search-select>
    </div>

    <div class="search-wrap grow">
      <i class="fa fa-comment-o"></i>
      <input
        type="text"
        name="message"
        [(ngModel)]="messageBroadcast"
        class="form-control"
        placeholder="Pesquisar por mensagem (texto do envio massivo)"
        data-testid="input-message"
      />
    </div>

    <div class="sort-wrap">
      <select
        name="orderBy"
        id="orderBy"
        class="form-select"
        [(ngModel)]="orderBy"
        [value]="orderBy"
        (change)="orderByChanged()"
        data-testid="select-order-by"
      >
        <option value="created_at">Ordenar por data</option>
        <option value="broadcast_status_id">Ordenar por status</option>
        <option value="leads_count">Ordenar por leads</option>
      </select>
      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon"
        [title]="invertedOrder ? 'Ordem crescente (inverter)' : 'Ordem decrescente (inverter)'"
        (click)="invertOrder()"
        data-testid="btn-invert-order"
      >
        <i class="fa" [class.fa-sort-amount-asc]="!invertedOrder" [class.fa-sort-amount-desc]="invertedOrder"></i>
      </button>
    </div>

    <button type="submit" class="sf-btn sf-btn--primary" data-testid="btn-filter">
      <i class="fa fa-search"></i> Pesquisar
    </button>
  </div>
</form>

<div *ngIf="administrator">
  <app-skeleton *ngIf="loading" variant="table-row" [count]="6" [columns]="5"
    label="Carregando os envios em massa" data-testid="broadcasts-filter-loading"></app-skeleton>

  <div *ngIf="!loading && result?.data.length > 0; else notFound" data-testid="broadcasts-filter-list">
    <div
      *ngFor="let broadcast of result.data"
      class="row-card"
      [class]="'tone-' + statusTone(broadcast)"
      [class.is-inactive]="isCancelled(broadcast)"
      data-testid="broadcast-filter-item"
    >
      <span class="row-avatar">
        <i class="fa fa-paper-plane-o"></i>
      </span>

      <div class="info">
        <div class="name">
          <a class="name-link" [routerLink]="['/broadcasts/view', broadcast.id]">{{ broadcast.name }}</a>
          <span class="status-pill status-pill--sm" [ngClass]="'status-pill--' + statusTone(broadcast)" data-testid="status-pill">
            {{ broadcast.broadcast_status_id | broadcastStatus }}
          </span>
        </div>

        <div class="meta-line">
          <span class="meta-chip" title="Usuário" data-testid="broadcast-user">
            <i class="fa fa-user"></i> {{ broadcast.user?.name || 'Desconhecido' }}
          </span>
          <span class="meta-chip" *ngIf="broadcast.broadcast_type?.name" title="Tipo de envio">
            <i class="fa fa-tag"></i> {{ broadcast.broadcast_type.name }}
          </span>
          <span class="meta-chip" title="Data envio"><i class="fa fa-calendar"></i> {{ broadcast.scheduled_date | date : "dd/MM/yyyy, H:mm" }}</span>
          <span class="meta-chip" *ngIf="broadcast.provider_account?.name" title="Provedor">
            <i class="fa fa-plug"></i> {{ broadcast.provider_account.name }}
          </span>
          <span class="meta-chip reason" *ngIf="isCancelled(broadcast) && broadcast.reason" title="Motivo do cancelamento">
            <i class="fa fa-info-circle"></i> {{ broadcast.reason }}
          </span>
        </div>

        <div class="msg-line" *ngIf="broadcast.message" title="{{ broadcast.message }}">
          <i class="fa fa-comment-o"></i> {{ broadcast.message }}
        </div>
      </div>

      <div class="stats">
        <div class="stat"><b>{{ broadcast.leads_count }}</b><span>Leads totais</span></div>
        <div class="stat" *ngIf="broadcast.short_url"><b>{{ broadcast.clicks || 0 }}</b><span>Total clicks</span></div>
      </div>

      <div class="icon-group">
        <a class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm" title="Ver detalhe" [routerLink]="['/broadcasts/view', broadcast.id]" data-testid="btn-view-broadcast">
          <i class="fa fa-eye"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<app-pagination
  *ngIf="!loading && result && result.data.length > 0"
  [currentPage]="result.current_page"
  [itemsPerPage]="result.per_page"
  [totalItems]="result.total"
  (pageChanged)="pageChanged($event)"
></app-pagination>

<ng-template #notFound>
  <div class="sf-card empty" *ngIf="!loading && user.validated" data-testid="no-broadcasts-filter">
    <i class="fa fa-search"></i>
    <p>Nenhum envio em massa realizado!</p>
  </div>
</ng-template>
